import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";


export default class OrderNotifications extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            fields: {},
            errors: {},
            isLoaded: true,
            activeLocation:null
        }

        this._bind(
            // 'getLocationDetailWithPvtConfig'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {

        // this.getLocationDetailWithPvtConfig();

    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        },()=>{
            this.loadOrderNotificationConfig();
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded == true) {
            this.setState({
                    activeLocation: nextProps.activeLocation
                },
                () => {
                    this.loadOrderNotificationConfig();
                });
        }
    }

    loadOrderNotificationConfig() {

        let activeLocation = this.state.activeLocation;

        let self = this;

        let pvtConfig = activeLocation.pvtConfig;
        if (!Utils.isEmptyObj(pvtConfig)) {

            let newOrderEmail = "";
            let orderRejEmail = "";
            let faxEmail = "";
            let orderUnattendedSMS = "";

            if (!Utils.isEmpty(pvtConfig.newOrderEmail)) {
                newOrderEmail = pvtConfig.newOrderEmail
            }
            if (!Utils.isEmpty(pvtConfig.orderRejEmail)) {
                orderRejEmail = pvtConfig.orderRejEmail
            }
            if (!Utils.isEmpty(pvtConfig.faxEmail)) {
                faxEmail = pvtConfig.faxEmail
            }
            if (!Utils.isEmpty(pvtConfig.orderUnattendedSMS)) {
                orderUnattendedSMS = pvtConfig.orderUnattendedSMS
            }

            self.setState({
                fields: {
                    newOrderEmail: newOrderEmail,
                    orderRejEmail: orderRejEmail,
                    faxEmail: faxEmail,
                    orderUnattendedSMS: orderUnattendedSMS
                },
            });

        }else {
            // self.setState({
            //     isLoaded: true,
            // });

        }

    }


    handleChange(field, e){

        let fields = this.state.fields;
        fields[field] = e.target.value;

        let statusValue = e.target.value;

        this.setState({fields});
    }

    handleValidation(){

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        //omLocationId
        // if(!fields["omLocationId"]){
        //     formIsValid = false;
        //     errors["omLocationId"] = "Cannot be empty";
        // }

        this.setState({errors: errors});
        return formIsValid;
    }

    updateLocationFormSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){

            let activeLocation = this.state.activeLocation;
            let locId = activeLocation.objectId;

            let self = this;
            self.setState({
                isLoaded : false,
                errors: {}
            });

            let fields = this.state.fields;

            // step - 3
            // Order Notifications
            let newOrderEmail = "";
            let orderRejEmail = "";
            let faxEmail = "";
            let orderUnattendedSMS = "";

            if (!Utils.isEmpty(fields["newOrderEmail"])){
                newOrderEmail = fields["newOrderEmail"];
            }
            if (!Utils.isEmpty(fields["orderRejEmail"])){
                orderRejEmail = fields["orderRejEmail"];
            }
            if (!Utils.isEmpty(fields["faxEmail"])){
                faxEmail = fields["faxEmail"];
            }
            if (!Utils.isEmpty(fields["orderUnattendedSMS"])){
                orderUnattendedSMS = fields["orderUnattendedSMS"];
            }


            let parameterObject = {};
            let pvtConfig = activeLocation.pvtConfig;

            if (!Utils.isEmptyObj(pvtConfig)) {
                // create the copy object of pvtConfig
                let pvtConfigCopy = pvtConfig;

                // check if the autoConfig is not empty then set the value
                // Otherwise remove the autoConfig key in pvt config
                if (!Utils.isEmptyObj(newOrderEmail)){
                    pvtConfigCopy["newOrderEmail"] = newOrderEmail.trim();
                }
                else {
                    // removed the "autoConfig" from the pvtConfig object
                    const { newOrderEmail, ...withoutAutoConfig } = pvtConfigCopy;
                    // assign to the pvtconfig object
                    pvtConfigCopy = withoutAutoConfig;
                }

                if (!Utils.isEmptyObj(orderRejEmail)){
                    pvtConfigCopy["orderRejEmail"] = orderRejEmail.trim();
                }
                else {
                    // removed the "autoConfig" from the pvtConfig object
                    const { orderRejEmail, ...withoutAutoConfig } = pvtConfigCopy;
                    // assign to the pvtconfig object
                    pvtConfigCopy = withoutAutoConfig;
                }

                if (!Utils.isEmptyObj(faxEmail)){
                    pvtConfigCopy["faxEmail"] = faxEmail.trim();
                }
                else {
                    // removed the "autoConfig" from the pvtConfig object
                    const { faxEmail, ...withoutAutoConfig } = pvtConfigCopy;
                    // assign to the pvtconfig object
                    pvtConfigCopy = withoutAutoConfig;
                }

                if (!Utils.isEmptyObj(orderUnattendedSMS)){
                    pvtConfigCopy["orderUnattendedSMS"] = orderUnattendedSMS.trim();
                }
                else {
                    // removed the "autoConfig" from the pvtConfig object
                    const { orderUnattendedSMS, ...withoutAutoConfig } = pvtConfigCopy;
                    // assign to the pvtconfig object
                    pvtConfigCopy = withoutAutoConfig;
                }

                parameterObject["pvtConfig"] = pvtConfigCopy;

            } else {

                parameterObject["pvtConfig"] = {};

                // check if the autoConfig is not empty then set the value
                // Otherwise remove the autoConfig key in pvt config
                if (!Utils.isEmptyObj(newOrderEmail)){
                    parameterObject["pvtConfig"]["newOrderEmail"] = newOrderEmail.trim();
                }

                if (!Utils.isEmptyObj(orderRejEmail)){
                    parameterObject["pvtConfig"]["orderRejEmail"] = orderRejEmail.trim();
                }

                if (!Utils.isEmptyObj(faxEmail)){
                    parameterObject["pvtConfig"]["faxEmail"] = faxEmail.trim();
                }

                if (!Utils.isEmptyObj(orderUnattendedSMS)){
                    parameterObject["pvtConfig"]["orderUnattendedSMS"] = orderUnattendedSMS.trim();
                }
            }

            // add the location id in objectId key
            parameterObject["objectId"] = locId;


            // console.log(JSON.stringify(parameterObject));

            this.updatePvtConfig(parameterObject);
        }
    }

    updatePvtConfig(paramsObject){

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;
        let self = this;


        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    alert("Order notifications config are updated successfully");

                    self.setState({
                        isLoaded: true
                    });

                    // Reload the data
                    self.props.reloadLocation();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded: true});
                    console.log("Error occured while fetching latest user data!");
                }
            );

    }


    render() {

        return (
            <div className="order-notification">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert">
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                        <div className="border-class marginTop">
                            <h4 id="translations" className="page-header">Order Notifications</h4>
                            <form name="updateLocationForm" className="updateLocationForm" onSubmit= {this.updateLocationFormSubmit.bind(this)}>

                                <div className="row form-group">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="labelName">New Order Email</label>
                                            <input type="text" className="form-control" id="newOrderEmail" ref="newOrderEmail"
                                                   aria-describedby="newOrderEmail" placeholder="New Order Email" onChange={this.handleChange.bind(this, "newOrderEmail")} value={this.state.fields["newOrderEmail"]}/>
                                            <span style={{color: "red"}} className="form-text">{this.state.errors["newOrderEmail"]}
                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="labelName">Order Reject Email</label>
                                            <input type="text" className="form-control" id="orderRejEmail" ref="orderRejEmail"
                                                   aria-describedby="orderRejEmail" placeholder="Order Reject Email" onChange={this.handleChange.bind(this, "orderRejEmail")} value={this.state.fields["orderRejEmail"]}/>
                                            <span style={{color: "red"}} className="form-text">{this.state.errors["orderRejEmail"]}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="labelName">Fax Email</label>
                                            <input type="text" className="form-control" id="faxEmail" ref="faxEmail"
                                                   aria-describedby="faxEmail" placeholder="Fax Email" onChange={this.handleChange.bind(this, "faxEmail")} value={this.state.fields["faxEmail"]}/>
                                            <span style={{color: "red"}} className="form-text">{this.state.errors["faxEmail"]}
                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="labelName">Order Unattended SMS (Mobile No)</label>
                                            <input type="number" className="form-control" id="orderUnattendedSMS" ref="orderUnattendedSMS"
                                                   aria-describedby="orderUnattendedSMS" placeholder="Enter Number" onChange={this.handleChange.bind(this, "orderUnattendedSMS")} value={this.state.fields["orderUnattendedSMS"]}/>
                                            <span style={{color: "red"}} className="form-text">{this.state.errors["orderUnattendedSMS"]}
                            </span>
                                        </div>
                                    </div>
                                </div>


                                <hr></hr>

                                <div className="form-group">
                                    <button type="submit" className="btn btn-export">Save</button>
                                    <button type="button" className="btn btn-default back-button"
                                            onClick={_ => this.props.reloadLocation()}>Cancel
                                    </button>
                                </div>
                                <hr></hr>

                            </form>
                        </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/order-notifications.js